import React, { useState, useEffect } from "react";
import "./Banner.css";
import axios from "axios";
import { api, api_key } from "../../api/Api";

const Banner = () => {
  const [movies, setMovies] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        `${api_key.react_api_Url}${api.fetchNetflixOriginals}`
      );
      setMovies(
        response.data.results[
          Math.floor(Math.random() * response.data.results.length - 1)
        ]
      );
      return response;
    };
    fetchData();
  }, []);
  //   const truncate = (str, n) => {
  //     return str.length > n ? str.substr(0, n - 1) + "..." : str;
  //   };
  return (
    <div>
      <header
        className='banner'
        style={{
          backgroundSize: "cover",
          backgroundImage: `Url('https://image.tmdb.org/t/p/original/${movies.backdrop_path}')`,
          backgroundPosition: "center center",
        }}
      >
        <div className='banner-contents'>
          <h1 className='banner-title'>
            {movies.title || movies.name || movies.original_name}
          </h1>
          <div className='banner-button'>
            <button className='banner-button button'>Play</button>
            <button className='banner-button button  buttons'>My List</button>
          </div>
          <h1 className='banner-description'>{movies.overview}</h1>
        </div>
        <div className='banner-fadeBottom'></div>
      </header>
    </div>
  );
};

export default Banner;
